import buttonBlockToFormInitialValues from './buttonBlockToFormInitialValues';

export default {
  pickBlockPropsToInitialValues: buttonBlockToFormInitialValues,
  getDefaultProps: () => ({
    alignment: 'left',
    label: 'Back',
  }),
};
